import { jsx } from '@emotion/react';
import { Fragment, useState, useEffect } from 'react';
import { Alert, Link } from '@zapier/design-system';
import { writeCookie, readCookie } from '@zapier/cookies';
export const shouldRender = (data, _shouldRender = false) => {
    const { currentAccount } = data;
    const hasDismissedBanner = readCookie('dismissedOverdueInvoiceBanner');
    return (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.hasOverdueInvoice) && !(hasDismissedBanner === 'true');
};
export const Component = function OverdueInvoice(props) {
    const [isExcludedUrl, setIsExcludedUrl] = useState(false);
    const [isDismissed, setIsDismissed] = useState(false);
    const { data } = props;
    const { currentAccount } = data;
    const periodEndDate = data.currentAccount.periodEndDate;
    const hasBillingPrivs = currentAccount.currentUserRole &&
        ['owner', 'super_admin'].includes(currentAccount.currentUserRole);
    useEffect(() => {
        setIsExcludedUrl(window.location.pathname.includes('checkout/invoice/pay'));
    }, []);
    const expiryDate = () => {
        if (periodEndDate) {
            return periodEndDate;
        }
        const defaultExpiry = new Date();
        defaultExpiry.setDate(defaultExpiry.getDate() + 30);
        return defaultExpiry;
    };
    const onDismiss = () => {
        writeCookie('dismissedOverdueInvoiceBanner', 'true', {
            category: 'essential',
            expires: expiryDate(),
        });
        setIsDismissed(true);
    };
    if (isDismissed || isExcludedUrl) {
        return null;
    }
    const title = (jsx("span", { "data-zds": true },
        "There was a problem with your last payment.",
        ' ',
        hasBillingPrivs ? (jsx(Link, { href: "/app/settings/billing" }, "Fix it now")) : (jsx(Fragment, null, "Please have an account owner update the payment information."))));
    return (jsx(Alert, { onDismiss: onDismiss, variant: props.variant, title: title, status: "error" }));
};
//# sourceMappingURL=OverdueInvoice.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
